<template>
  <div class="animated fadeIn list-of-invissued">
    <b-card>
      <div slot="header">List of Issued Reserved 
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit">Edit</b-button>
          <!-- <b-button variant="btn btn-primary mr-1" @click="retur()" :disabled="disabledRetur"><i class="fa fa-repeat"></i> RETUR</b-button> -->
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm">Delete</b-button>
          <!-- <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="posting()">
              <i class="fa fa-paper-plane"></i> Posting
          </button>
          <b-dropdown text="Print" variant="primary mr-1" >
            <b-dropdown-item @click="print" >Print BPB</b-dropdown-item>
            <b-dropdown-item @click="printjv" :disabled="(model.posting == 0)">Journal Voucher</b-dropdown-item>
          </b-dropdown> -->

          <button class="btn btn-primary mr-1" @click="togleFilter()">
            <i class="fa fa-filter"></i> Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
          <b-input-group>
              <b-input-group-prepend><label>Issued Doc No.</label></b-input-group-prepend>
              <b-form-input v-model="tblData.issuedno"  placeholder="Nomor (% for wildcard)"></b-form-input>
              <b-input-group-append><span class="input-group-text"> By </span></b-input-group-append>
              <b-form-input v-model="tblData.createby" placeholder="Issued By"></b-form-input>
          </b-input-group>
          <b-input-group>
              <b-input-group-prepend><label>Issued Date</label></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl1" type="date" placeholder="from date"></b-form-input>
              <b-input-group-append><span class="input-group-text">-</span></b-input-group-append>
              <b-form-input v-model="tblData.tgl2" type="date" placeholder="until date"></b-form-input>
          </b-input-group>
          <b-input-group>
              <b-input-group-prepend><label>Item/Description</label></b-input-group-prepend>
              <b-form-input v-model="tblData.itemname" placeholder="Item Name" @change="itemChange"></b-form-input>
                <b-input-group-append>
                <b-btn text="Button" @click="lkuItemShow=true" >
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>
              <b-form-input v-model="tblData.uraian" placeholder="Description" class="ml-1"></b-form-input>
          </b-input-group>
          <b-input-group >
              <b-input-group-prepend><label>Issued/Usage</label></b-input-group-prepend>
              <b-form-select v-model="tblData.issueGrpkey"  :plain="true" :options="issuedGroups" style="width:40% !important;"></b-form-select>
              <b-input-group-prepend><span class="input-group-text">Posting &nbsp;</span></b-input-group-prepend>
              <b-form-select v-model="tblData.posting" :plain="true" :options="dataList.postingStatus"></b-form-select>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-input-group>
              <b-input-group-prepend><label>Store/Warehouse</label></b-input-group-prepend>
              <b-form-select v-model="tblData.idStore" :plain="true" :options="dataList.warehouse"></b-form-select>
            <b-input-group-prepend><span class="p-2">Request/Reff#</span></b-input-group-prepend>
              <b-form-input v-model="tblData.requestno" placeholder="Request Number"></b-form-input>
          </b-input-group>
          <b-input-group>
              <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
              <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
              <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value" class="ml-1"></b-form-input>
              <b-input-group-append>
              <b-btn text="Button" @click="lkuDimShow=true">
                  <i class="fa fa-search"></i>
              </b-btn>
              </b-input-group-append>
          </b-input-group>
          <b-input-group>
              <b-input-group-prepend><label>Item Group/Category</label></b-input-group-prepend>
              <b-form-input v-model="tblData.headcategory" placeholder="Head Category"></b-form-input>
              <b-form-input v-model="tblData.nmcategory" placeholder="Category" class="ml-1"></b-form-input>
          </b-input-group>
          <b-row class="justify-content-center">
              <b-input-group>
                <b-input-group-append>
                    <b-button class="btn btn-success ml-3" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                </b-input-group-append>
                <b-input-group-append>
                  <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
                </b-input-group-append>

              </b-input-group>
          </b-row>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"  @row-clicked="rowClicked" 
        show-empty
      >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#"  style="padding:0 !important;">Edit</b-dropdown-item>
          <!-- <b-dropdown-item @click="rowReturn(data.item)" :disabled="disabledRetur" href="#" style="padding:0 !important;">Return</b-dropdown-item> -->
          <!-- <b-dropdown-item @click="rowPost(data.item)" href="#" v-if="(data.item.posting==1)" style="padding:0 !important;">Un Posting</b-dropdown-item> -->
          <!-- <b-dropdown-item @click="rowPost(data.item)" href="#" v-if="(data.item.posting==0)" style="padding:0 !important;">Posting</b-dropdown-item> -->
          <!-- <b-dropdown-item @click="rowPrint(data.item)" href="#" style="padding:0 !important;">Print BPB</b-dropdown-item> -->
          <!-- <b-dropdown-item @click="rowPrintJv(data.item)" href="#" style="padding:0 !important;">Print JV</b-dropdown-item> -->
          <b-dropdown-item @click="rowDel(data.item)" href="#"  style="padding:0 !important;"> Delete</b-dropdown-item>
        </b-dropdown>
      </template>        
        <template v-slot:cell(nomor)="data">
          <div v-if="data.item.posting==0" style="background-color:yellow;">
            <span v-if="(data.item.isReturn == 1)" style="color:red">{{data.item.nomor}}</span>
            <span v-else>{{data.item.nomor}}</span>
          </div>
          <div v-else>          
            <span v-if="(data.item.isReturn == 1)" style="color:red">{{data.item.nomor}}</span>
            <span v-else>{{data.item.nomor}}</span>
          </div>
        </template>
        <template v-slot:cell(tanggal)="data">
          {{ data.item.tanggal | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(qtyIssued)="data">
          <span v-if="(data.item.isReturn == 1)" style="color:red">{{data.item.qtyIssued}} &nbsp; {{data.item.invunitom}}</span>
          <span v-else>{{data.item.qtyIssued}} &nbsp; {{data.item.invunitom}}</span>
        </template>
        <template v-slot:cell(nilai)="data">
          <span v-if="(data.item.issueValue)">{{data.item.issueValue|numFormat}}</span>
        </template>
        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row >
        <b-col cols="4">
          <div class="pt-1">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="5">          
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>  
              <b-pagination
                v-if="pagination" 
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
          </b-input-group>
        </b-col>
        <b-col cols="3" >
          <div class="text-right pt-1">
            <span style="background-color:yellow;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="mr-2">Record Not Posted</span>
          </div>
        </b-col>        
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
      <b-modal v-model="showPostingConfirm" title="Posting Record?" :centered="true" @ok="postingData">
        <p class="mb-1">The selected a row of data will be Posted to Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">You can unpost as long as <strong>Accounting Periode</strong> stil open</p>
      </b-modal>
      <b-modal v-model="showUnpostConfirm" title="Un Posting Record?" :centered="true" @ok="unpostData">
        <p class="mb-1">The selected a row of data will be UnPosted from Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">Data Journal will be removed from <strong>Accounting</strong></p>
      </b-modal>
    </b-card>

        <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="List of Master Item Inventory" :centered="true">
            <lku-item @click="onSelectLkuItem"  jasa="0" isactive="1" :formdata="itemList" ></lku-item>
        </b-modal>        
        <b-modal v-model="lkuDimShow" size="lg" :hide-footer="true" title="List of Dimension Value" :centered="true" >
            <lku-dim @click="onSelectedDim" :DimColName="tblData.DimCol" :key="tblData.DimCol"></lku-dim>
        </b-modal>        

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" scrollable size="xl" title="Preview as PDF" hide-footer>
        <iframe :src="reportUrl" frameborder="0"></iframe>
        <b-row class="justify-content-center mt-1">
            <b-button variant="primary" v-if="(isprintjv==true)" @click.stop="editjv">Edit Journal</b-button>
            <b-button variant="secondary" class="ml-2" @click="showReport=false" > Close</b-button>
        </b-row>
    </b-modal>
  </div>
</template>

<style lang="scss">
  .list-of-invissued {
    table {
      td {
        .dropdown-item {
            padding: 0.1rem 1.5rem !important;
            font-size: smaller !important;
        }    
      }
    }
   
  }

</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import lkuItem from "../lookup/lkuItemLazzy";
import lkuDim from "../lookup/lkuDim";
import invout from "../../apis/logistic_inv_out";
import invoutreserved from "../../apis/logistic_inv_out_reserved";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
toastr.init();

export default {
  components: {Loading,lkuItem,lkuDim},
  data() {
    return {
      lkuItemShow:false,
      itemList:{},
      lkuDimShow:false,

      showFilter: false,
      showDelConfirm: false,
      showPostingConfirm: false,
      showUnpostConfirm: false,
      disabledRetur:false,
      isLoading:false,
      isprintjv: false,
      showReport:false,
      reportUrl: null,
      model:{},
      items: [],
      limit:15,
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        tgl1:'',
        tgl2:'',
        sortBy: 'nomor',
        sortDesc: false,
        DimCol:'Dim1',
        idStore:'',
        headcategory:'',
        nmcategory:''
      },
      pagination:false,
      issuedGroups:[{value:'', text:'--ALL--'}],
      dataList: {
        openStatus: dropdown.openClose,
        postingStatus: dropdown.postingStatus,
        warehouse:[{value:'', text:'--ALL--'}],
      }      
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    tblFields(){
      const fields=[
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },          
        {
            key: "nomor",
            label: "Issued Number",
            sortable: true
          },
          {
            key: "tanggal",
            thStyle: "width:90px",
            label: "Issued Date",
            sortable: true
          },
        {
            key: "requestno",
            label: "Requisition#",
            sortable: true
          },
          {
            key: "namaStore",
            label: "Warehouse",
            sortable: true
          },
          {
            key: "nmcategory",
            label: "Inventory Group",
            sortable: true
          },
          {
            key: "itemname",
            label: "Item Inventory",
            sortable: true
          },
          {
            key: "qtyIssued",
            label: "Quantity",
            thStyle: "width:80px",
            tdClass: "text-right"
          },
          {
            key: "matauang",
            label: "$,¥",
            sortable: true
          },
          {
            key: "nilai",
            label: "Value",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "uraian",
            label: "Issued Description",
            sortable: true
          },
          {
            key: "receivby",
            label: "Received By",
            sortable: true
          },
        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          fields.push(          {
            key: `${dims[i].value}Txt`,
            // thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }
      return fields;
    },
    // dimCol() {
    //     return this.tblData.DimCol;
    // }    
  },
  watch:{
    // dimCol: function(newval) {
    //     this.tblData.DimVal="";
    //     this.tblData.DimValInfo="";
    //     this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    // },
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },    

  },
  created: async function(){
      const [a,b] = await Promise.all([invout.issuegroup(),invout.store()]) ;
      this.issuedGroups = this.issuedGroups.concat(a);
      this.dataList.warehouse = this.dataList.warehouse.concat(b);
  },  
  methods: {
    onSelectLkuItem: function (lkuData) {
        this.itemList=lkuData;
        this.lkuItemShow=false;

        this.tblData.itemno = lkuData.selected.itemno;
        this.tblData.itemname = lkuData.selected.itemname;
    },
    itemChange: function () {
        this.tblData.itemno = '';
    },
    onSelectedDim: function(_selected){
        // this.tblData.DimVal=_selected.kode;
        // this.tblData.DimValInfo=`${_selected.kode.trim()} | ${_selected.nama}`;
        this.tblData.DimVal=`${_selected.nama.trim()}`;
        this.lkuDimShow=false;
    },

    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
   data: async function(ctx) {
    //     const filter = this.$store.state.filter;
    //     let filtered=false;
    //     for (var key in filter.InvOutList) {
    //         this.tblData[key] = filter.InvOutList[key];
    //         filtered=true;
    //     }
    //     if (filtered === true) {
    //       if (!(filter.InvOutList.tgl1)) {
    //         this.tblData.tgl1='';
    //         this.tblData.tgl2='';
    //       }
    //       this.showFilter=filtered;
    //       delete filter.InvOutList;
    //       this.$store.commit("filter", filter);
    //       // this.$store.commit("filter", {});
    //     }
    //   this.isLoading=true;
    //   this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
    //   const list = await invout.list(this.tblData);   
    //   this.items=list;  
    //   this.isLoading=false;
    //  return list;
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.InvOutList) {
            this.tblData[key] = filter.InvOutList[key];
            filtered=true;
        }
        if (filtered === true) {
          if (!(filter.InvOutList.tgl1)) {
            this.tblData.tgl1='';
            this.tblData.tgl2='';
          }
          this.showFilter=filtered;
          delete filter.InvOutList;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await invoutreserved.list(this.tblData);      
                  this.pagination=true;
                  this.items = list;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
            }
        } else {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await invoutreserved.list(this.tblData);      
                  this.pagination=true;
                  this.items = list;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
        }
    },    
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },    
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.kodeaccc= '';
        this.tblData.partnumber=  '';
        this.tblData.itemno=  '';
        this.tblData.itemname=  '';
        this.tblData.posting=  '';
        this.tblData.uraian=  '';
        this.tblData.issuedno=  '';
        this.tblData.createby=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';
        this.tblData.issueGrpkey=  '';
        this.tblData.idStore='';
        this.tblData.headcategory='';
        this.tblData.nmcategory='';
    },
    saveFilter() {
      const keys = ['sortBy','sortDesc','issuedno', 'uraian', 'idStore', 'nmcategory', 'headcategory', 'requestno', 'tgl1', 'tgl2', 'DimCol', 'DimColInfo', 'DimVal', 'createby'];
      let filtered = false;
      const InvOutList={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              InvOutList[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          InvOutList.page=this.tblData.page;
          InvOutList.limit=this.tblData.limit;
          InvOutList.sortBy=this.tblData.sortBy;
          InvOutList.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.InvOutList=InvOutList;
          this.$store.commit("filter", filter);
      }
    },    
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowReturn(record) {
      this.model = record;
      this.retur();
    },
    rowPost(record) {
      this.rowClicked(record);
        this.posting();        
    },
    rowPrint(record) {
      this.rowClicked(record);
        this.print();        
    },
    rowPrint(record) {
      this.rowClicked(record);
        this.printjv();        
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },
    add(){
      this.saveFilter();
      router.push({name :"logistic.issued-reserved-form"});
    },
    edit: function() {
        if (this.model.invIssueKey ) {
          this.saveFilter();
          router.push({name :'logistic.issued-reserved-form', params: { invIssueKey: this.model.invIssueKey}});
        } else if (this.model.invIssueKey && this.model.isReturn && this.model.invIssueKeyB4) {
          this.saveFilter();
          router.push({name :'logistic.issuedretur', params: { invIssueKey: this.model.invIssueKey}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    editjv: function() {
        if (this.model.invIssueKey) {
            this.saveFilter();
            const tanggal = moment(this.model.tanggal).format('YYYY-MM-DD');
          router.push({name :'logistic.editjvfrm', params: { nomor: this.model.nomor, tanggal, kodejurnal:'APINV', fsubkode2:'ap_invoice_tt',kodefield2:'apinvkey',subkode2: this.model.apinvkey}});
          // router.push({name :'payable.editjvfrm', params: { nomor: this.model.nomor, tanggal: this.model.tanggal}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },

    retur: function() {
        if (this.model.invIssueKey) {
          if(this.model.isReturn === 1){
            toastr.warn('Please select other row that want to be Retur!');
          }else{
            router.push({name :'logistic.issuedretur', params: { invIssueKeyB4: this.model.invIssueKey}});
          }
          
        } else {
            toastr.warn('Please select a row that want to be Retur!');
        }
    },
    deleteConfirm() {
        if (this.model.invIssueKey) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        await invout.removeReserved(this.model);
      this.refresh();
        // const index= this.items.findIndex(r => (r.invIssueKey==this.model.invIssueKey));
        // this.items.splice(index, 1);
        this.isLoading=false;
      } catch (error) {
        this.isLoading=false;
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },

    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      if(record.isReturn === 1){
        this.disabledRetur=true;
      }else{
        this.disabledRetur=false;
      }

      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    posting: async function () {
        if (this.model.invIssueKey) {
            if ((this.model.posting || 0) == 0) {
                this.showPostingConfirm = true;
            }
            if (this.model.posting == 1) {
                this.showUnpostConfirm = true;
            }
        } else {
            toastr.warn('Please select a row that want to be Posted!');
        }
    }, 
    postingData: async function(){
        this.isLoading=true;
        try {
            await invout.posting(this.model);
            this.isLoading=false;
            this.printjv();
            this.refresh();
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    unpostData: async function(){
        this.isLoading=true;
        try {
            await invout.postingUndo(this.model);
            this.isLoading=false;
            this.refresh();
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    print: async function()
    {
      if (this.model.invIssueKey) {
        try {
              if ((this.model.posting || 0) == 0) {
                await invout.posting(this.model);
                this.model.posting=1;
              }

                this.showReport=true;
              this.isprintjv=false;
              this.reportUrl= await invout.print(this.model);
              this.isLoading=false;
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    printjv: async function()
    {
      if (this.model.invIssueKey) {
          this.isLoading=true;
          try {
                this.showReport=true;
              this.isprintjv=true;
              this.reportUrl= await invout.printjv(this.model);
              this.isLoading=false;
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            await invout.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
        }
    },    
    close(){
      router.push("/logistic/home");
    },    
  }
};
</script>
